(function(){
  'use strict';
  var $=function(s,r){return (r||document).querySelector(s)};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};

  /* reveal on scroll */
  function reveal(){
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els=$$('[data-reveal]:not(.is-in)');
    if(reduced||!('IntersectionObserver' in window)){
      els.forEach(function(e){e.classList.add('is-in')});
      return;
    }
    var io=new IntersectionObserver(function(en){en.forEach(function(e){
      if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}
    })},{threshold:.1,rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e){io.observe(e)});
  }

  /* soft parallax on media */
  function parallax(){
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var nodes=$$('[data-parallax]');
    if(!nodes.length) return;
    var ticking=false;
    function update(){
      var vh=window.innerHeight;
      nodes.forEach(function(el){
        var r=el.getBoundingClientRect();
        if(r.bottom<0||r.top>vh) return;
        var p=(r.top+r.height/2-vh/2)/(vh/2);
        var amp=parseFloat(el.getAttribute('data-parallax'))||12;
        el.style.transform='translate3d(0,'+(p*amp*-1).toFixed(1)+'px,0) scale(1.08)';
      });
      ticking=false;
    }
    function onScroll(){
      if(ticking) return;
      ticking=true;
      requestAnimationFrame(update);
    }
    window.addEventListener('scroll',onScroll,{passive:true});
    update();
  }

  function bumpCount(){
    $$('[data-cart-count]').forEach(function(el){
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
      setTimeout(function(){el.classList.remove('is-bump')},500);
    });
  }

  /* announcement rotator */
  function announce(){
    var bar=$('[data-announce]'); if(!bar) return;
    var items=$$('.ok-announce__item',bar); if(items.length<2) return;
    var i=0, ms=parseInt(bar.getAttribute('data-interval'),10)||4200;
    setInterval(function(){items[i].classList.remove('is-on');i=(i+1)%items.length;items[i].classList.add('is-on')},ms);
  }

  /* header: mega menu, search, mobile nav + sticky scroll state */
  function header(){
    var group=document.querySelector('.shopify-section-group-header-group')||$('.ok-header');
    if(group){
      var onScroll=function(){
        group.classList.toggle('is-scrolled', window.scrollY>12);
      };
      onScroll();
      window.addEventListener('scroll',onScroll,{passive:true});
    }
    var trig=$('[data-mega-trigger]'), panel=$('[data-mega]'), t;
    if(trig&&panel){
      var open=function(){clearTimeout(t);panel.hidden=false;trig.setAttribute('aria-expanded','true')};
      var close=function(){clearTimeout(t);t=setTimeout(function(){panel.hidden=true;trig.setAttribute('aria-expanded','false')},220)};
      var wrap=trig.closest('.ok-nav__item')||trig;
      [wrap,panel].forEach(function(el){el.addEventListener('mouseenter',open);el.addEventListener('mouseleave',close)});
      trig.addEventListener('click',function(e){
        /* desktop: apri mega senza navigare; mobile: lascia il link */
        if(window.matchMedia('(min-width:981px)').matches){
          e.preventDefault();
          if(panel.hidden) open(); else { clearTimeout(t); panel.hidden=true; trig.setAttribute('aria-expanded','false'); }
        }
      });
    }
    var sBtn=$('[data-search-toggle]'), sPanel=$('[data-search]');
    if(sBtn&&sPanel){sBtn.addEventListener('click',function(){
      sPanel.hidden=!sPanel.hidden; if(!sPanel.hidden){var f=$('input',sPanel); f&&f.focus(); if(panel)panel.hidden=true}
    })}
    var burger=$('[data-burger]'), nav=$('[data-nav]');
    if(burger&&nav){burger.addEventListener('click',function(){nav.classList.toggle('is-open')})}
    document.addEventListener('keydown',function(e){
      if(e.key!=='Escape')return;
      if(panel)panel.hidden=true; if(sPanel)sPanel.hidden=true;
      var d=$('[data-cart-drawer]'); if(d)d.hidden=true;
    });
  }

  /* predictive search */
  function search(){
    var input=$('[data-search] input'), out=$('[data-search-results]'), meta=$('[data-search-meta]');
    if(!input||!out) return;
    var timer, ctl;
    input.addEventListener('input',function(){
      clearTimeout(timer);
      var q=input.value.trim();
      if(q.length<2){out.innerHTML='';if(meta)meta.textContent='';return}
      timer=setTimeout(function(){
        if(ctl)ctl.abort(); ctl=('AbortController' in window)?new AbortController():null;
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6',
          ctl?{signal:ctl.signal}:{})
        .then(function(r){return r.json()})
        .then(function(d){
          var ps=(d.resources&&d.resources.results&&d.resources.results.products)||[];
          out.innerHTML=ps.map(function(p){
            return '<a class="ok-search__row" href="'+p.url+'"><span><strong>'+p.title+'</strong><small>'+(p.vendor||'')+'</small></span><span style="color:var(--ok-gold)">'+(p.price||'')+'</span></a>';
          }).join('');
          if(meta)meta.textContent=ps.length?ps.length+' risultati':'Nessun risultato';
        }).catch(function(){});
      },220);
    });
  }

  /* hero slideshow */
  function hero(){
    var root=$('[data-hero]'); if(!root) return;
    var copies=$$('[data-hero-copy]',root), slides=$$('[data-hero-slide]',root), dots=$$('[data-hero-dot]',root);
    if(!copies.length) return;
    var i=0, ms=parseInt(root.getAttribute('data-interval'),10)||7000, timer;
    function syncVideos(active){
      slides.forEach(function(slide,x){
        var vids=$$('video',slide);
        vids.forEach(function(v){
          if(x===active){
            try{ if(v.paused) v.play(); }catch(e){}
          } else {
            try{ v.pause(); }catch(e){}
          }
        });
      });
    }
    function go(n){
      i=(n+copies.length)%copies.length;
      copies.forEach(function(e,x){e.classList.toggle('is-on',x===i)});
      slides.forEach(function(e,x){e.classList.toggle('is-on',x===i)});
      dots.forEach(function(e,x){e.setAttribute('aria-current',x===i?'true':'false')});
      syncVideos(i);
    }
    dots.forEach(function(d,x){d.addEventListener('click',function(){go(x);restart()})});
    function restart(){
      clearInterval(timer);
      if(copies.length<2) return;
      timer=setInterval(function(){go(i+1)},ms);
    }
    syncVideos(0);
    restart();
  }

  /* PDP gallery + zoom */
  function pdp(){
    var main=$('[data-pdp-main]'); if(!main) return;
    var img=$('img',main);
    /* no zoom / motion on product page — thumbs only swap image */
    $$('[data-pdp-thumb]').forEach(function(b){
      b.addEventListener('click',function(){
        img.src=b.getAttribute('data-full');
        $$('[data-pdp-thumb]').forEach(function(x){x.setAttribute('aria-current','false')});
        b.setAttribute('aria-current','true');
      });
    });
  }

  /* variant picker */
  function variants(){
    var form=$('[data-variant-form]'); if(!form) return;
    var raw=$('[data-variant-json]');
    var data=[];
    try{ data=JSON.parse((raw&&raw.textContent)||'[]'); }catch(e){ data=[]; }
    var idInput=$('[data-variant-id]',form), btn=$('[data-add-btn]',form), unit=$('[data-variant-unit]');
    var opts=$$('[data-opt]',form);

    function applyVariant(v){
      if(!v){
        if(btn){ btn.disabled=true; btn.textContent='Non disponibile'; }
        return;
      }
      if(idInput) idInput.value=v.id;
      $$('[data-variant-price]').forEach(function(el){ el.innerHTML=v.price; });
      $$('[data-variant-compare]').forEach(function(el){
        if(v.compare){
          el.innerHTML=v.compare;
          el.hidden=false;
        }else{
          el.innerHTML='';
          el.hidden=true;
        }
      });
      if(unit){
        var show=v.title && v.title!=='Default Title';
        unit.textContent=show?v.title:'';
        unit.hidden=!show;
      }
      if(btn){
        btn.disabled=!v.available;
        btn.textContent=v.available?(btn.getAttribute('data-label')||'Aggiungi al carrello'):'Esaurito';
      }
    }

    function update(){
      if(!opts.length){
        applyVariant(data[0]);
        return;
      }
      var picked=opts.filter(function(i){return i.checked}).map(function(i){return i.value});
      var v=data.filter(function(x){return (x.options||[]).join('~')===picked.join('~')})[0];
      if(!v && data.length===1) v=data[0];
      applyVariant(v);
    }

    opts.forEach(function(i){ i.addEventListener('change',update); });
    update();
  }

  /* cart drawer + GTM ecommerce */
  function pushDL(payload){
    window.dataLayer = window.dataLayer || [];
    if(payload && payload.ecommerce){ window.dataLayer.push({ ecommerce: null }); }
    window.dataLayer.push(payload);
  }
  function cartCurrency(){
    return (window.OK_DL && window.OK_DL.currency) || undefined;
  }
  function pushViewCart(){
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    return fetch(root.replace(/\/?$/,'/')+'cart.js',{credentials:'same-origin'})
      .then(function(r){return r.json()})
      .then(function(c){
        if(!c || !c.item_count) return;
        pushDL({
          event:'view_cart',
          ecommerce:{
            currency: c.currency || cartCurrency(),
            value: (c.total_price||0)/100,
            items: (c.items||[]).map(function(it){
              return {
                item_id: String(it.product_id||it.id),
                item_name: it.product_title || it.title,
                item_brand: it.vendor,
                item_variant: it.variant_title,
                price: (it.final_price!=null?it.final_price:it.price||0)/100,
                quantity: it.quantity||1
              };
            })
          }
        });
      }).catch(function(){});
  }
  function cart(){
    if(window.__okCartBound) return;
    window.__okCartBound=true;
    function getDrawer(){ return $('[data-cart-drawer]'); }
    function openDrawer(){
      var drawer=getDrawer(); if(!drawer) return;
      drawer.classList.remove('is-ready');
      drawer.hidden=false;
      drawer.removeAttribute('hidden');
      document.documentElement.classList.add('ok-drawer-open');
      window.clearTimeout(window.__okDrawerReady);
      window.__okDrawerReady=window.setTimeout(function(){
        var d=getDrawer(); if(d && !d.hidden) d.classList.add('is-ready');
      }, 320);
    }
    function closeDrawer(){
      var drawer=getDrawer(); if(!drawer) return;
      window.clearTimeout(window.__okDrawerReady);
      drawer.classList.remove('is-ready');
      drawer.hidden=true;
      drawer.setAttribute('hidden','');
      document.documentElement.classList.remove('ok-drawer-open');
    }
    function syncCounts(root){
      var c=(root||document).querySelector('[data-cart-count]');
      if(!c) return;
      $$('[data-cart-count]').forEach(function(el){ el.textContent=c.textContent; });
      bumpCount();
    }
    function render(){
      var drawer=getDrawer();
      if(!drawer) return Promise.resolve();
      var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      return fetch(root.replace(/\/?$/,'/')+'?sections=cart-drawer')
        .then(function(r){return r.json()})
        .then(function(json){
          var html=json['cart-drawer']||'';
          if(!html) return;
          var doc=new DOMParser().parseFromString(html,'text/html');
          var fresh=doc.querySelector('[data-cart-drawer]');
          if(fresh){ drawer.innerHTML=fresh.innerHTML; }
          syncCounts(doc);
        })
        .catch(function(){
          return fetch(root.replace(/\/?$/,'/')+'?section_id=cart-drawer')
            .then(function(r){return r.text()})
            .then(function(html){
              var doc=new DOMParser().parseFromString(html,'text/html');
              var fresh=doc.querySelector('[data-cart-drawer]');
              if(fresh){ drawer.innerHTML=fresh.innerHTML; }
              syncCounts(doc);
            }).catch(function(){});
        });
    }
    document.addEventListener('click',function(ev){
      var card=ev.target.closest('[data-select-item]');
      if(card && ev.target.closest('a[href]')){
        pushDL({
          event:'select_item',
          ecommerce:{
            currency: cartCurrency(),
            items:[{
              item_id: card.getAttribute('data-item-id'),
              item_name: card.getAttribute('data-item-name'),
              item_brand: card.getAttribute('data-item-brand'),
              item_category: card.getAttribute('data-item-category'),
              price: parseFloat(card.getAttribute('data-item-price')||'0')
            }]
          }
        });
      }
      if(ev.target.closest('[data-cart-open]')){
        ev.preventDefault();
        openDrawer();
        pushViewCart();
        return;
      }
      var drawer=getDrawer();
      if(!drawer||drawer.hidden) return;
      if(ev.target.closest('[data-cart-close]')||ev.target.classList.contains('ok-drawer__bg')){
        ev.preventDefault();
        closeDrawer();
        return;
      }
      var rm=ev.target.closest('[data-cart-remove]');
      if(rm && drawer.contains(rm)){
        ev.preventDefault();
        var qty=parseInt(rm.getAttribute('data-item-qty')||'1',10);
        var price=parseFloat(rm.getAttribute('data-item-price')||'0');
        pushDL({
          event:'remove_from_cart',
          ecommerce:{
            currency: cartCurrency(),
            value: price * qty,
            items:[{
              item_id: rm.getAttribute('data-item-id'),
              item_name: rm.getAttribute('data-item-name'),
              item_brand: rm.getAttribute('data-item-brand'),
              item_variant: rm.getAttribute('data-item-variant'),
              price: price,
              quantity: qty
            }]
          }
        });
        fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:rm.getAttribute('data-cart-remove'),quantity:0})})
          .then(function(){render()}).catch(function(){});
        return;
      }
      var qty=ev.target.closest('[data-cart-qty]');
      if(qty && drawer.contains(qty)){
        ev.preventDefault();
        fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:qty.getAttribute('data-line-key'),quantity:parseInt(qty.getAttribute('data-cart-qty'),10)})})
          .then(function(){render()}).catch(function(){});
      }
    });
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape') closeDrawer();
    });

    document.addEventListener('submit',function(e){
      var checkoutForm=e.target.closest('.ok-drawer__foot');
      if(checkoutForm && e.submitter && (e.submitter.getAttribute('name')==='checkout' || e.submitter.hasAttribute('data-begin-checkout'))){
        /* fire begin_checkout then let the form continue to Shopify checkout */
        e.preventDefault();
        var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
        fetch(root.replace(/\/?$/,'/')+'cart.js',{credentials:'same-origin'})
          .then(function(r){return r.json()})
          .then(function(c){
            pushDL({
              event:'begin_checkout',
              ecommerce:{
                currency: c.currency || cartCurrency(),
                value: (c.total_price||0)/100,
                items: (c.items||[]).map(function(it){
                  return {
                    item_id: String(it.product_id||it.id),
                    item_name: it.product_title || it.title,
                    item_brand: it.vendor,
                    item_variant: it.variant_title,
                    price: (it.final_price!=null?it.final_price:it.price||0)/100,
                    quantity: it.quantity||1
                  };
                })
              }
            });
          })
          .catch(function(){})
          .then(function(){
            var f=document.createElement('form');
            f.method='post';
            f.action=checkoutForm.getAttribute('action') || ((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'cart';
            var i=document.createElement('input');
            i.type='hidden'; i.name='checkout'; i.value='';
            f.appendChild(i);
            document.body.appendChild(f);
            f.submit();
          });
        return;
      }
      var form=e.target.closest('[data-quick-add],[data-variant-form]');
      if(!form)return;
      /* lascia passare Apple Pay / Shop Pay / Google Pay */
      if(e.target.closest('.shopify-payment-button, shopify-accelerated-checkout, [data-shopify-buttoncontainer]')) return;
      if(e.submitter && e.submitter.closest && e.submitter.closest('.shopify-payment-button')) return;
      if(form.matches('[data-variant-form]') && e.submitter && !e.submitter.matches('[data-add-btn],button[name="add"],.ok-btn')) return;
      e.preventDefault();
      e.stopPropagation();
      var btn=(e.submitter&&e.submitter.matches('[data-add-btn],button'))?e.submitter:($('[data-add-btn]',form)||$('button[type="submit"]',form)||$('button',form));
      var old=btn?btn.textContent:'';
      if(btn){ btn.disabled=true; btn.textContent='…'; }
      var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
      var fd=new FormData(form);
      fetch(root.replace(/\/?$/,'/')+'cart/add.js',{
        method:'POST',
        body:fd,
        credentials:'same-origin',
        headers:{'Accept':'application/json'}
      })
        .then(function(r){
          return r.json().then(function(body){
            if(!r.ok) throw body;
            return body;
          });
        })
        .then(function(line){
          if(line.status && line.message) throw line;
          if(btn){ btn.disabled=false; btn.textContent=old; }
          var price=(line.final_price!=null?line.final_price:(line.price||0))/100;
          pushDL({
            event:'add_to_cart',
            ecommerce:{
              currency: line.presentment_currency || cartCurrency(),
              value: price * (line.quantity||1),
              items:[{
                item_id: String(line.product_id||line.id),
                item_name: line.product_title || line.title,
                item_brand: line.vendor,
                item_variant: line.variant_title,
                price: price,
                quantity: line.quantity||1
              }]
            }
          });
          /* refresh content first, then open once — avoids double slide-in */
          return render().then(function(){ openDrawer(); });
        })
        .catch(function(err){
          if(btn){ btn.disabled=false; btn.textContent=old; }
          console.warn('Okishori cart add', err);
          openDrawer();
        });
    });

    /* /cart → apri subito il drawer laterale */
    if(document.body.classList.contains('template-cart')){
      openDrawer();
      pushViewCart();
    }
  }

  /* brand logo letter reveal */
  function logo(){
    var root=$('[data-logo]'); if(!root) return;
    var word=$('[data-logo-word]',root);
    if(!word){ root.classList.add('is-ready'); return; }
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      root.classList.add('is-ready');
      return;
    }
    if(word.querySelector('.ok-logo__ch')) return;
    var text=word.textContent||'';
    word.textContent='';
    Array.prototype.forEach.call(text,function(ch,i){
      var s=document.createElement('span');
      s.className='ok-logo__ch';
      s.style.setProperty('--i', String(i));
      s.textContent=ch === ' ' ? '\u00A0' : ch;
      word.appendChild(s);
    });
    root.classList.add('is-ready');
  }

  function init(){
    logo();announce();header();search();hero();pdp();variants();cart();
    if(!document.body.classList.contains('template-product')){
      reveal();
      parallax();
    }
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',function(){
    if(!document.body.classList.contains('template-product')){
      reveal();
      parallax();
    }
  });
})();